export default function MatchConfidence({ confidence, t }) {
  if (!confidence) return null;

  const styles = {
    high: 'border-emerald-500/40 bg-emerald-950/30 text-emerald-300',
    medium: 'border-amber-500/40 bg-amber-950/30 text-amber-200',
    low: 'border-slate-500/40 bg-slate-800/50 text-slate-400',
  };

  return (
    <span
      className={`text-xs rounded-full px-2 py-1 border ${styles[confidence.level] || styles.medium}`}
    >
      {t.confidence[confidence.labelKey]}
    </span>
  );
}
